import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ViewQuizComponent } from './view-quiz.component';
import { ViewQuizQuestionComponent } from './view-quiz-question/view-quiz-question.component';
import { ViewQuizProgressComponent } from './view-quiz-progress/view-quiz-progress.component';
import { ContentBlocksModule } from 'src/app/content-blocks/content-blocks.module';
import { MaterialModule } from 'src/app/material.module';
import { ButtonsModule } from 'src/app/shared/components/buttons/buttons.module';
import { IconModule } from 'src/app/shared/components/icon/icon.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { ViewQuizAnswerComponent } from './view-quiz-answer/view-quiz-answer.component';
import { ListModule } from 'src/app/shared/components/list/list.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ViewQuizReviewComponent } from './view-quiz-review/view-quiz-review.component';
import { ViewQuizObjectTreeComponent } from './view-quiz-object-tree/view-quiz-object-tree.component';
import { ViewQuizAnswerOptionComponent } from './view-quiz-answer/option/view-quiz-answer-option.component';
import { ViewQuizMultipleChoiceAnswerComponent } from './view-quiz-answer/answers/multiple-choice/view-quiz-multiple-choice-answer.component';
import { ViewQuizSelectAnatomyAnswerComponent } from './view-quiz-answer/answers/select-anatomy/view-quiz-select-anatomy-answer.component';
import { ViewQuizLabelAnatomyComponent } from './view-quiz-label-anatomy/view-quiz-label-anatomy.component';
import { ViewQuizLabelAnatomyAnswerComponent } from './view-quiz-answer/answers/label-anatomy/view-quiz-label-anatomy-answer.component';
import { QuizModule } from 'src/app/quiz/quiz.module';
import { ViewQuizAnswerNumberComponent } from './view-quiz-answer/number/view-quiz-answer-number.component';
import { ProgressIndictatorsModule } from 'src/app/shared/components/progress-indicators/progress-indicators.module';

@NgModule({
  declarations: [
    ViewQuizComponent,
    ViewQuizQuestionComponent,
    ViewQuizProgressComponent,
    ViewQuizAnswerComponent,
    ViewQuizReviewComponent,
    ViewQuizObjectTreeComponent,
    ViewQuizAnswerOptionComponent,
    ViewQuizMultipleChoiceAnswerComponent,
    ViewQuizSelectAnatomyAnswerComponent,
    ViewQuizLabelAnatomyComponent,
    ViewQuizLabelAnatomyAnswerComponent,
    ViewQuizAnswerNumberComponent
  ],
  exports: [
    ViewQuizComponent,
    ViewQuizProgressComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ButtonsModule,
    DirectivesModule,
    IconModule,
    ContentBlocksModule,
    ListModule,
    ReactiveFormsModule,
    QuizModule,
    ProgressIndictatorsModule
  ]
})
export class ViewQuizModule { }
